
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9457"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9457"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $jqz8H = parcelRequire("jqz8H");

var $gOZE9 = parcelRequire("gOZE9");
function $bca014d2ac32cd9a$var$getColour(index, opacity) {
    const colours = [
        `rgba(54, 162, 235, ${opacity})`,
        `rgba(255, 99, 132, ${opacity})`,
        `rgba(255, 206, 86, ${opacity})`,
        `rgba(75, 192, 192, ${opacity})`,
        `rgba(153, 102, 255, ${opacity})`,
        `rgba(255, 159, 64, ${opacity})`,
        `rgba(201, 203, 207, ${opacity})`,
        `rgba(111, 214, 155, ${opacity})`,
        `rgba(204, 102, 153, ${opacity})`,
        `rgba(95, 162, 206, ${opacity})` // light blue
    ];
    return colours[index % colours.length];
}
function $bca014d2ac32cd9a$var$convertDataIntoDataset(portfoliosData) {
    // convert data to datasets
    // Get all unique stock names across all portfolios
    const allStocks = new Set();
    portfoliosData.forEach((portfolioData)=>{
        Object.keys(portfolioData.portfolio).forEach((stock)=>{
            allStocks.add(stock);
        });
    });
    // Convert to array and sort alphabetically
    const stocksArray = Array.from(allStocks).sort();
    // Create a dataset for each stock
    // Each dataset contains an array which says what the value is the stock in the person's portfolio
    // The person is determined via array index, e.g. 0 is Julian
    const datasets = stocksArray.map((stock, index)=>{
        const data = portfoliosData.map((portfolioData)=>{
            if (portfolioData.portfolio[stock]) return portfolioData.portfolio[stock].value;
            return 0; // Portfolio doesn't have this stock
        });
        return {
            label: stock,
            data: data,
            backgroundColour: $bca014d2ac32cd9a$var$getColour(index, 0.7),
            borderColour: $bca014d2ac32cd9a$var$getColour(index, 1),
            borderWidth: 1
        };
    });
    return datasets;
}
function $bca014d2ac32cd9a$var$createStockInfo(portfoliosData) {
    let stocksInfo = {};
    portfoliosData.forEach((portfolioData)=>{
        const portfolioName = portfolioData.name;
        if (!stocksInfo[portfolioName]) stocksInfo[portfolioName] = {};
        Object.keys(portfolioData.portfolio).forEach((stock)=>{
            const shares = portfolioData.portfolio[stock]['shares held'];
            const value = portfolioData.portfolio[stock]['value'];
            const pricePerShare = value / shares;
            stocksInfo[portfolioName][stock] = {
                shares: shares,
                value: value,
                pricePerShare: pricePerShare
            };
        });
    });
    return stocksInfo;
}
// Create the chart
function $bca014d2ac32cd9a$var$createChart(portfoliosData) {
    const ctx = document.getElementById('portfolioChart').getContext('2d');
    const datasets = $bca014d2ac32cd9a$var$convertDataIntoDataset(portfoliosData);
    console.log(datasets);
    // Get labels from portfolio names
    const labels = portfoliosData.map((portfolio)=>portfolio.name);
    // Calculate the total values for display
    const totals = portfoliosData.map((portfolio)=>portfolio.portfolio_value);
    const stocksInfo = $bca014d2ac32cd9a$var$createStockInfo(portfoliosData);
    portfolioChart = new (0, $jqz8H.default)(ctx, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                    title: {
                        display: true,
                        text: 'Portfolios'
                    }
                },
                y: {
                    stacked: true,
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: `Value (${(0, $gOZE9.CURRENCY_NAME)})`
                    }
                }
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Portfolios',
                    font: {
                        size: 18
                    }
                },
                tooltip: {
                    callbacks: {
                        afterTitle: function(context) {
                            const portfolioIndex = context[0].dataIndex;
                            const portfolioName = labels[portfolioIndex];
                            return `Total Value: ${totals[portfolioIndex]} ${0, $gOZE9.CURRENCY_NAME}`;
                        },
                        label: function(context) {
                            const stockName = context.dataset.label;
                            const portfolioIndex = context.dataIndex;
                            const portfolioName = labels[portfolioIndex];
                            if (stocksInfo[portfolioName] && stocksInfo[portfolioName][stockName]) {
                                const info = stocksInfo[portfolioName][stockName];
                                return [
                                    `${stockName}: ${info.value} ${(0, $gOZE9.CURRENCY_NAME)}`,
                                    `Price per Share: ${info.pricePerShare} ${(0, $gOZE9.CURRENCY_NAME)}`,
                                    `Shares Held: ${info.shares}`
                                ];
                            }
                            return `${stockName}: $0 (not in portfolio)`;
                        }
                    }
                },
                legend: {
                    display: false
                }
            }
        }
    });
}
parcelRequire("kjyEk");
const $bca014d2ac32cd9a$var$portfoliosData = JSON.parse('[{"name": "Julian", "portfolio_value": 125, "portfolio": {"Inscryption": {"shares held": 1, "value": 0}, "Deaths Door": {"shares held": 1, "value": 0}, "Silicon Dreams": {"shares held": 1, "value": 5}, "Paradise Killer": {"shares held": 1, "value": 4}, "Star Renegades": {"shares held": 2, "value": 0}, "Citizen Sleeper": {"shares held": 3, "value": 0}, "In Other Waters": {"shares held": 1, "value": 2}, "Endling": {"shares held": 1, "value": 2}, "Signalis": {"shares held": 1, "value": 0}, "Young Souls": {"shares held": 1, "value": 3}, "Mo:Astray": {"shares held": 1, "value": 4}, "Wyldermyth": {"shares held": 1, "value": 5}, "Stray Gods": {"shares held": 1, "value": 4}, "Yuppie Psycho": {"shares held": 1, "value": 3}, "Pseudoregalia": {"shares held": 2, "value": 14}, "Shadows of Doubt": {"shares held": 1, "value": 0}, "VIDEOVERSE": {"shares held": 1, "value": 0}, "Animal Well": {"shares held": 1, "value": 3}, "Nine Sols": {"shares held": 2, "value": 42}, "Lorelai and the Laser Eyes": {"shares held": 1, "value": 5}, "Tactical Breach Wizards": {"shares held": 1, "value": 0}, "Suzerain": {"shares held": 1, "value": 0}, "Citizen Sleeper 2 Starward Vector": {"shares held": 1, "value": 0}, "Tiny Terry\'s Turbo Trip": {"shares held": 1, "value": 3}, "Blue Prince": {"shares held": 1, "value": 5}, "Wolfenstien 3D": {"shares held": 1, "value": 0}, "Cryptmaster": {"shares held": 1, "value": 3}, "Signs of the Sojourner": {"shares held": 2, "value": 18}}}, {"name": "Lee", "portfolio_value": 72, "portfolio": {"Cruelty Squad": {"shares held": 3, "value": 0}, "Invisible Inc": {"shares held": 1, "value": 0}, "Omori": {"shares held": 1, "value": 7}, "Neon White": {"shares held": 1, "value": 0}, "Off": {"shares held": 2, "value": 8}, "Metal Hellsinger": {"shares held": 3, "value": 0}, "Signalis": {"shares held": 1, "value": 0}, "Ghostlore": {"shares held": 1, "value": 4}, "Cross Code": {"shares held": 1, "value": 0}, "Pizza Tower": {"shares held": 1, "value": 2}, "World of Horror": {"shares held": 1, "value": 0}, "Faith: The Unholy Trinity": {"shares held": 1, "value": 2}, "No Straight Roads": {"shares held": 1, "value": 5}, "Deathbulge": {"shares held": 1, "value": 2}, "Anomaly Agent": {"shares held": 1, "value": 1}, "Felvidek": {"shares held": 3, "value": 30}, "1000xResist": {"shares held": 1, "value": 5}, "Sorry We\'re Closed": {"shares held": 2, "value": 0}, "Fretless - The Wrath of Riffson": {"shares held": 1, "value": 2}, "BURGGEIST": {"shares held": 1, "value": 4}}}, {"name": "Anton", "portfolio_value": 184, "portfolio": {"VA-11 Hall-A": {"shares held": 4, "value": 52}, "NORCO": {"shares held": 1, "value": 0}, "Umurangi Generation": {"shares held": 1, "value": 3}, "Card Shark": {"shares held": 1, "value": 0}, "Coffee Talk": {"shares held": 1, "value": 3}, "Signalis": {"shares held": 1, "value": 0}, "Kentucky Route Zero": {"shares held": 1, "value": 4}, "A Space for the Unbound": {"shares held": 3, "value": 36}, "The Hong Kong Massacre": {"shares held": 2, "value": 14}, "Omori": {"shares held": 1, "value": 7}, "El Paso": {"shares held": 1, "value": 3}, "Lunacid": {"shares held": 2, "value": 12}, "Islands of the Caliph": {"shares held": 1, "value": 3}, "Tunic": {"shares held": 1, "value": 8}, "Crow Country": {"shares held": 2, "value": 22}, "Slay the Princess": {"shares held": 2, "value": 0}, "Contraband Police": {"shares held": 1, "value": 3}, "Dread Delusion": {"shares held": 1, "value": 3}, "Uplink": {"shares held": 1, "value": 6}, "The Drifter": {"shares held": 1, "value": 5}}}, {"name": "Korey", "portfolio_value": 8, "portfolio": {"Outer Wilds": {"shares held": 2, "value": 8}, "Unpacking": {"shares held": 4, "value": 0}}}, {"name": "Alex", "portfolio_value": 17, "portfolio": {"We were here": {"shares held": 1, "value": 1}, "Superliminal": {"shares held": 1, "value": 4}, "Return of the Obra Dinn": {"shares held": 2, "value": 0}, "Frog Detective: The Entire Mystery": {"shares held": 2, "value": 12}}}, {"name": "Andy", "portfolio_value": 177, "portfolio": {"Hotline Miami": {"shares held": 1, "value": 2}, "Bad North": {"shares held": 1, "value": 3}, "Sable": {"shares held": 2, "value": 0}, "Tunic": {"shares held": 1, "value": 8}, "Atone: Heart of the Elder Tree": {"shares held": 3, "value": 30}, "Dredge": {"shares held": 2, "value": 0}, "Chained Echoes": {"shares held": 1, "value": 6}, "Sifu": {"shares held": 2, "value": 16}, "Laika": {"shares held": 1, "value": 2}, "Balatro": {"shares held": 1, "value": 0}, "Nine Sols": {"shares held": 4, "value": 84}, "Harold Halibut": {"shares held": 1, "value": 2}, "The Voidness": {"shares held": 1, "value": 4}, "Loco Motive": {"shares held": 1, "value": 3}, "Primal Planet": {"shares held": 1, "value": 0}, "Limbo": {"shares held": 1, "value": 4}, "Eclipsium": {"shares held": 1, "value": 3}, "Skate Story": {"shares held": 1, "value": 5}, "Mind Diver": {"shares held": 1, "value": 5}}}, {"name": "Tom", "portfolio_value": 0, "portfolio": {"Spiritfarer": {"shares held": 1, "value": 0}, "Ori and the Blind Forest": {"shares held": 5, "value": 0}}}, {"name": "Jason", "portfolio_value": 86, "portfolio": {"Card Shark": {"shares held": 2, "value": 0}, "Blind Drive": {"shares held": 2, "value": 0}, "Oxenfree": {"shares held": 3, "value": 27}, "Darkest Dungeon": {"shares held": 1, "value": 2}, "A highland Song": {"shares held": 1, "value": 2}, "Sephonie": {"shares held": 1, "value": 4}, "Chants of Sennaar": {"shares held": 3, "value": 42}, "Potion Craft": {"shares held": 1, "value": 0}, "Hypnospace Outlaw": {"shares held": 1, "value": 3}, "Devotion": {"shares held": 1, "value": 6}}}, {"name": "Emalee", "portfolio_value": 30, "portfolio": {"Stardew Valley": {"shares held": 1, "value": 4}, "Potion Craft": {"shares held": 4, "value": 0}, "A Little to the Left": {"shares held": 1, "value": 3}, "Fran Bow": {"shares held": 1, "value": 3}, "Cult of the Lamb": {"shares held": 1, "value": 3}, "Just Shapes & Beats": {"shares held": 1, "value": 3}, "Machinarium": {"shares held": 1, "value": 4}, "Still Wakes the Deep": {"shares held": 1, "value": 4}, "Road 96": {"shares held": 1, "value": 6}}}, {"name": "Emma", "portfolio_value": 15, "portfolio": {"Five nights at Freddy\'s": {"shares held": 1, "value": 2}, "Haste": {"shares held": 1, "value": 0}, "World of Goo": {"shares held": 1, "value": 5}, "Labyrinth of the Demon King": {"shares held": 1, "value": 3}, "Noita": {"shares held": 1, "value": 0}, "The Sexy Brutale": {"shares held": 1, "value": 5}}}, {"name": "Zach", "portfolio_value": 13, "portfolio": {"DarkMaus": {"shares held": 1, "value": 3}, "Downwell": {"shares held": 1, "value": 3}, "GRIS": {"shares held": 1, "value": 3}, "Spiritfarer": {"shares held": 1, "value": 0}, "Pumpkin Jack": {"shares held": 1, "value": 3}, "Star of Providence": {"shares held": 1, "value": 1}}}, {"name": "Harry", "portfolio_value": 10, "portfolio": {"Drop Duchy": {"shares held": 1, "value": 3}, "Potion Craft": {"shares held": 1, "value": 0}, "Cogs": {"shares held": 1, "value": 4}, "Darkwood": {"shares held": 1, "value": 0}, "Diceomancer": {"shares held": 1, "value": 1}, "Fretless - The Wrath of Riffson": {"shares held": 1, "value": 2}}}]');
$bca014d2ac32cd9a$var$createChart($bca014d2ac32cd9a$var$portfoliosData);


//# sourceMappingURL=frontend.8179de27.js.map
